export function handleNavigation() {
    let $body = $('body');
    $body.on('click', '.js-mobile-navigation', function () {
        $('body').toggleClass('show-navigation');
        return false;
    }).on('click', '.js-toggle-dropdown', function(){
        $(this).parents('.header-navigation__item').toggleClass('header-navigation__item--dropdown-active');

        return false;
    });

    handleStickyNav();
}

export function updateStickyNav() {
    let scrollTop = $(window).scrollTop();
    if (scrollTop === 0) {
        $('body').removeClass('body-show-sticky-nav');
        return;
    }

    if (scrollTop > $(".js-header").outerHeight()) {
        $('body').addClass('body-show-sticky-nav');
    }
}

export function handleStickyNav() {
    let $window = $(window);
    let $header = $('.js-header');
    let $navToggle = $('.js-nav-toggle');
    let lastScroll = $window.scrollTop();
    let currentOffset = 0;

    updateStickyNav();

    $window.on("scroll", function () {

        updateStickyNav();

        if ($header.hasClass('header-always-sticky')) {
            $header.css("transform", "");
            return;
        }

        let scroll = $window.scrollTop();
        let diff = lastScroll - scroll;
        let height = $header.outerHeight();

        currentOffset = Math.min(0, Math.max(-height, currentOffset + diff));

        let visibleHeader = Math.min(height, Math.max(0, height + currentOffset));
        $('body').css({'--visible-header': visibleHeader + 'px'});

        if (scroll <= 0) {
            currentOffset = 0;
        }

        lastScroll = scroll;

        if (currentOffset === 0) {
            $header.css("transform", "");
        } else {
            $header.css("transform", "translateY(" + currentOffset + "px)");
        }

    }).on("resize", function () {
        lastScroll = $window.scrollTop();
        $header.css("transform", "");
        $navToggle.css("transform", "");
        currentOffset = 0;
    });
}
